import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { styled } from '@linaria/react';
import { ReviewsTrackClick, SelectedElementType } from 'components/Accommodation/DateGuestInput/ReviewsTrackClick';
import difference from 'lodash/difference';
import { RatingType } from 'types/Hotel';
import { reviewsLabels } from 'utils/reviewsMessages';
import ContentWrapper from '@daedalus/atlas/helpers/ContentWrapper';
import { ReviewSummaryBar } from '@daedalus/atlas/ReviewSummaryBar';
import { Text } from '@daedalus/atlas/Text';
import { useDispatchTeamEvent } from '@daedalus/core/src/analytics/components/TeamContext';
import { trackEvent } from '@daedalus/core/src/analytics/modules/actions';
import { Action, Category, Entity } from '@daedalus/core/src/analytics/types/Events';
import FormattedMessageWrapper from '@daedalus/core/src/localization/components/FormattedMessage';
import { RATING_EXCLUDED_FROM_DISPLAY, RATING_PRIORITY_ORDER } from './constants';
const RatingsListWrapper = /*#__PURE__*/styled('div')({
  name: "RatingsListWrapper",
  class: "r1cm5np2",
  propsAsIs: false
});

/**
 * Filter out excluded keys, order keys by the priority and append
 * any keys not listed in the priority order at the end
 * @param ratings - list of rating keys
 * @returns modified/ordered list of rating keys available for display
 */
export const orderedAvailableRatings = (ratings: string[]) => {
  const filteredInputRatings = ratings.filter(rating => !RATING_EXCLUDED_FROM_DISPLAY.includes(rating));
  const orderedAvailable = RATING_PRIORITY_ORDER.filter(ordered => filteredInputRatings.includes(ordered));
  return orderedAvailable.concat(difference(orderedAvailable, filteredInputRatings));
};
interface Props {
  guestRating: RatingType;
}
export const SummarySubsection: React.FC<Props> = ({
  guestRating
}) => {
  const ratingsToDisplay = useMemo(() => orderedAvailableRatings(Object.keys(guestRating)), [guestRating]);
  const dispatchTeamEvent = useDispatchTeamEvent();
  const onClick = (type: SelectedElementType) => {
    dispatchTeamEvent(trackEvent({
      category: Category.User,
      entity: Entity.HotelDetailsReviewsSection,
      action: Action.Clicked,
      payload: {
        selectedElement: type
      }
    }));
  };
  const {
    formatMessage
  } = useIntl();
  return <>
      <ContentWrapper paddingBottom="s500">
        <Text variant="titleM">
          <ReviewsTrackClick stopPropagation element={SelectedElementType.RatingHeader} entity={Entity.HotelDetailsReviewsSection}>
            <FormattedMessageWrapper id="reviews.ratingSummary" defaultMessage="Rating summary" />
          </ReviewsTrackClick>
        </Text>
      </ContentWrapper>

      <RatingsListWrapper>
        {ratingsToDisplay.map(rating => <div key={rating} onClick={() => onClick(SelectedElementType.RatingElement)} role="presentation">
            <ReviewSummaryBar value={guestRating[rating]}>
              {formatMessage(reviewsLabels[rating])}
            </ReviewSummaryBar>
          </div>)}
      </RatingsListWrapper>
    </>;
};

require("./SummarySubSections.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./SummarySubSections.tsx");